// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Checkmark-module--cds--assistive-text--da4d5";
export var cdsHideFeedback = "Checkmark-module--cds--hide-feedback--0ff0c";
export var cdsShowFeedback = "Checkmark-module--cds--show-feedback--ce40e";
export var cdsSkeleton = "Checkmark-module--cds--skeleton--f5da9";
export var cdsVisuallyHidden = "Checkmark-module--cds--visually-hidden--e4644";
export var drawStroke = "Checkmark-module--drawStroke--50e95";
export var path = "Checkmark-module--path--511ff";
export var svg = "Checkmark-module--svg--61a1b";